/* eslint-disable max-len */
import React from 'react'

const CoverBlock = () => {
   const handleScrollToFeatures = () => {
      const section = document.getElementById('features')
      const scrollPosition = section.offsetTop - 88

      window.scrollTo({
         top: scrollPosition,
         behavior: 'smooth'
      })
   }

   return (
      <div className="bg-[#041310]/70">
         <div className="communities-content-wrapper pt-32 sm:pt-36 md:pt-48 lg:pt-32 xl:pt-40 pb-4 sm:pb-24">
            <div className="flex flex-col-reverse lg:grid grid-cols-12 gap-16">
               <div className="col-span-12 lg:col-span-6 md:px-24 lg:px-0">
                  <div className="relative w-full aspect-square lg:aspect-[3.2/4] xl:aspect-[3.2/4] rounded-t-[50%] lg:rounded-l-none lg:rounded-r-[40%] overflow-hidden">
                     <video
                        className="relative w-full h-full object-cover lg:object-[90%_0%]"
                        poster="/assets/custom/communities/images/splash-poster.jpg"
                        autoPlay
                        muted
                        loop
                        playsInline>
                        <source
                           src="/assets/custom/communities/media/communities-splash.mp4"
                           type="video/mp4"
                        />
                     </video>
                  </div>
               </div>
               <div className="col-span-12 lg:col-span-6 flex flex-col items-center lg:items-start justify-center xl:pb-16 text-center lg:text-left">
                  <div className="text-[37px] sm:text-[40px] md:text-[48px] lg:text-[40px] xl:text-[48px] font-medium tracking-tighter leading-[1.1em] text-white my-2 xl:mt-16 text-balance max-w-[480px] md:max-w-[540px] font-serif-title">
                     Build a place to bring&nbsp; your community&nbsp;
                     <br className="hidden lg:block" />
                     together
                  </div>
                  <div className="w-24 h-2 lg:w-40 lg:h-4 bg-white my-4" />
                  <div className="max-w-[440px] py-4 text-base text-white opacity-70">
                     The simple, all-in-one platform to help you build a place for your community to gather, engage, and share the ideas, opportunities and things that matter most.
                  </div>
                  <div>
                     <button
                        type="button"
                        onClick={handleScrollToFeatures}
                        className="inline-flex items-center h-12 gap-4 bg-green-300 text-black text-base
               mt-8 rounded-full pl-8 pr-8 cursor-pointer hover:bg-white active:bg-white/60 transition-all duration-300 hover:translate-y-[-4px] active:translate-y-0 font-semibold">
                        Learn More
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default CoverBlock
